import React from 'react';
import { connect } from 'react-redux';

import { Login, Main, PageLoading, Register, Forgot, Reset, PopUp, Verification, UnVerified, MobileSelfie } from './Template';

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ProtectedRoute from './router/ProtectedRoute';
import PublicRoute from './router/PublicRoute';

const Home = React.lazy(() => import('./features/Beranda'));
const Personal = React.lazy(() => import('./features/Personal'));
const KetentuanTrading = React.lazy(() => import('./features/KetentuanTrading'));
const ProfilePerusahaan = React.lazy(() => import('./features/ProfilePerusahaan'));
const Pernyataan = React.lazy(() => import('./features/Pernyataan'));
const TypeAccount = React.lazy(() => import('./features/TypeAccount'));
const Setting = React.lazy(() => import('./features/Personal/Setting'));
const HubungiKami = React.lazy(() => import('./features/HubungiKami'));
const Unduh = React.lazy(() => import('./features/Unduh'));
const Setoran = React.lazy(() => import('./features/Setoran'));
const RejectDoc = React.lazy(() => import('./features/RejectDocument'));
const Penarikan = React.lazy(() => import('./features/Penarikan'));
const Autochartist = React.lazy(() => import('./features/Autochartist'));
const AkunBank = React.lazy(() => import('./features/AkunBank'));
const AddBank = React.lazy(() => import('./features/AkunBank/AddBank'));
const Transfer = React.lazy(() => import('./features/Transfer'));
const YukBelajar = React.lazy(() => import('./features/YukBelajar'));
const DetailEduc = React.lazy(() => import('./features/YukBelajar/Detail'));

//New Page Component
const SimulasiPerdagangan = React.lazy(() => import('./features/Pernyataan/SimulasiPerdagangan'));
const PengalamanTrading = React.lazy(() => import('./features/Pernyataan/PengalamanTrading'));
const PernyataanPengungkapan = React.lazy(() => import('./features/Pernyataan/PernyataanPengungkapan'));
const InformasiResiko = React.lazy(() => import('./features/Pernyataan/InformasiResiko'));
const PemberianAmanat = React.lazy(() => import('./features/Pernyataan/PemberianAmanat'));
const TradingRules = React.lazy(() => import('./features/Pernyataan/TradingRules'));
const KodeAkses = React.lazy(() => import('./features/Pernyataan/KodeAkses'));
const PenggunaanDanaSendiri = React.lazy(() => import('./features/Pernyataan/PenggunaanDanaSendiri'));
const VerifikasiKelengkapan = React.lazy(() => import('./features/Pernyataan/VerifikasiKelengkapan'));

const getBasename = path => path.substr(0, path.lastIndexOf('/'));
function App({ main }) {
  
  return (
    <div className="App">
      <Router basename={getBasename(window.location.pathname)}>
        <Switch>
          <Route exact path="/verifikasi" component={Verification} />
          <PublicRoute exact path="/login">
            <Login />
          </PublicRoute>

          <PublicRoute exact path="/register">
            <Register />
          </PublicRoute>

          <PublicRoute exact path="/forgot">
            <Forgot />
          </PublicRoute>

          <PublicRoute exact path="/reset">
            <Reset />
          </PublicRoute>
          
          <PublicRoute exact path="/upload-selfie">
            <MobileSelfie />
          </PublicRoute>

          <ProtectedRoute exact path="/popup">
            <PopUp />
          </ProtectedRoute>

          <PublicRoute path="/unverified">
            <Main>
              <React.Suspense fallback={<PageLoading />}>
                <Route exact path="/unverified" component={UnVerified} />
                </React.Suspense>
            </Main>
          </PublicRoute>

          <ProtectedRoute path="/">
            <Main>
              <React.Suspense fallback={<PageLoading />}>
                <Route exact path="/" component={Home} />
                <Route exact path="/personal" component={Personal} />
                <Route exact path="/trading_rules" component={KetentuanTrading} />
                <Route exact path="/company_profile" component={ProfilePerusahaan} />
                <Route exact path="/decleration" component={Pernyataan} />
                <Route exact path="/account-type" component={TypeAccount} />
                <Route exact path="/downloads" component={Unduh} />
                <Route exact path="/contact" component={HubungiKami} />
                <Route exact path="/deposit" component={Setoran} />
                <Route exact path="/setting" component={Setting} />
                <Route exact path="/rej-doc" component={RejectDoc} />
                <Route exact path="/withdrawal" component={Penarikan} />
                <Route exact path="/autochartist" component={Autochartist} />
                <Route exact path="/bank-accounts" component={AkunBank} />
                <Route exact path="/add-bank-accounts" component={AddBank} />
                <Route exact path="/internal-transfer" component={Transfer} />
                <Route exact path="/education" component={YukBelajar} />
				        <Route exact path="/detail-artikel" component={DetailEduc} />
				        <Route exact path="/statement_trading_simulation" component={SimulasiPerdagangan} />
				        <Route exact path="/statement_trading_experience" component={PengalamanTrading} />
				        <Route exact path="/statement_disclosure_1" render={(routeProps) => <PernyataanPengungkapan {...routeProps} statementNo={1} />} />
				        <Route exact path="/statement_disclosure_2" render={(routeProps) => <PernyataanPengungkapan {...routeProps} statementNo={2} />} />
				        <Route exact path="/statement_disclosure_3" render={(routeProps) => <PernyataanPengungkapan {...routeProps} statementNo={3} />} />
				        <Route exact path="/statement_risk_notification" component={InformasiResiko} />
				        <Route exact path="/statement_mandate" component={PemberianAmanat} />
				        <Route exact path="/statement_trading_rules" component={TradingRules} />
				        <Route exact path="/statement_access_code" component={KodeAkses} />
				        <Route exact path="/statement_funds_used" component={PenggunaanDanaSendiri} />
				        <Route exact path="/statement_verification" component={VerifikasiKelengkapan} />
              </React.Suspense>
            </Main>
          </ProtectedRoute>
        </Switch>
      </Router>

    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    main: state.main.currentUser
  }
}

export default connect(mapStateToProps)(App);
